import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { ActivityTypesResponse } from "../../models/dtos"; 

export const activityTypesApi = createApi({
  reducerPath: 'activityTypesApi',
  baseQuery: baseAuthQuery('ActivityTypes'),
  tagTypes: ['ActivityType'],
  endpoints: (builder) => ({
    getActivityTypes: builder.query<ApiResponse<ActivityTypesResponse[]>, void>({
      query: () => "",
      providesTags: ['ActivityType'],
    }),
    getActivityTypesById: builder.query<ApiResponse<ActivityTypesResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['ActivityType'],
    }),
  }),
});
